module.exports = __webpack_public_path__ + "static/media/patchedx2.02286531.svg";